import { render, staticRenderFns } from "./DesktopUI.vue?vue&type=template&id=4a03bbef&"
import script from "./DesktopUI.vue?vue&type=script&lang=js&"
export * from "./DesktopUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports